import React from "react"
//import styled from "@emotion/styled"
//import tw from "twin.macro"
import { withIcon } from "./withIcon"
import { useWindowSize } from "../../hooks/useWindowSize"

export const Icon = withIcon(({ icon, size, title, ...props }) => {
  const {
    windowSize: { isMobile },
  } = useWindowSize()

  return (
    <>
      {icon ? (
        (title && title === "afterpay") ||
        title === "applepay" ||
        title === "amex" ||
        title === "googlepay" ||
        title === "visa" ||
        title === "mastercard" ||
        title === "ShopPay" ||
        title === "backbutton" ? (
          <>
            {!isMobile ? (
              title === "backbutton" ? (
                <img src={icon} {...props} height={26} width={14} />
              ) : (
                <img src={icon} {...props} height={30} width={50} />
              )
            ) : title === "backbutton" ? (
              <img src={icon} {...props} height={18} width={10} />
            ) : (
              <img src={icon} {...props} height={22} width={37} />
            )}
          </>
        ) : (
          <img src={icon} {...props} height={size} width={size} />
        )
      ) : (
        <p>[{title}]</p>
      )}
    </>
  )
})
